import { useBoxSource } from '@/modules/upload/cloud/box/useBoxSource'
import {
  CloudImportButton,
  type ProviderImportButtonProps,
} from './CloudImportButton'
import { BoxIcon } from './ProviderIcons'

export const BoxImportButton = (props: ProviderImportButtonProps) => {
  const source = useBoxSource()
  if (!source) return null
  return <CloudImportButton source={source} icon={<BoxIcon />} {...props} />
}
